export default defineNuxtRouteMiddleware(() => {
  if (import.meta.server) return

  const { auth, initAuth } = useAuth()

  initAuth()

  if (!auth.value) {
    window.location.href = '/auth'
    return abortNavigation()
  }
})
